export const PROFILE_FEED_MENU_POST_TYPE_FILTER = 'profile-feed-menu-post-type-filter';
export const PROFILE_CREATE_POST_SELECT_TYPE_MENU = 'profile-create-post-select-type-menu';
